import { DownCaretIcon } from '../assets/svgImages';
import { PatientStatusProps, PatientTypeProps } from '../constant/constant';
import Select, { DropdownIndicatorProps, components } from 'react-select';
import {
  BulkEmailDetailSelectProps,
  FiltersState,
} from '../interface/interface';

const PatientDetailsSelect = (props: BulkEmailDetailSelectProps) => {
  const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className="flex align-items">
      <div className="me-5">
        <label className="text-lg font-semibold text-secondary-pink-700">
          Status <span className="text-red-500">*</span>
        </label>
        <Select
          className="w-72 cursor-pointer"
          value={
            props.filters?.status?.value
              ? (props.filters.status as any)
              : undefined
          }
          options={PatientStatusProps as any}
          onChange={(selected) =>
            props.setFilters((prev: FiltersState | undefined) => ({
              ...prev!,
              status: selected as any,
            }))
          }
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
      <div>
        <label className="text-lg font-semibold  text-secondary-pink-700">
          Patient Type <span className="text-red-500">*</span>
        </label>
        <Select
          className="w-72 cursor-pointer"
          value={
            props.filters?.selectedPatientType?.value
              ? (props.filters.selectedPatientType as any)
              : undefined
          }
          options={PatientTypeProps as any}
          onChange={(selected) =>
            props.setFilters((prev: FiltersState | undefined) => ({
              ...prev!,
              selectedPatientType: selected as any,
            }))
          }
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
        />
      </div>
    </div>
  );
};

export default PatientDetailsSelect;
